import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import useAuth from 'hooks/use-auth'
import { trackPage } from 'track'

/**
 * This is a wrapper for tracking page views in Segment, adapted for React Router v6. It is intended to be used in place
 * of TrackedGremlinRoute.
 */
export const TrackedGremlinRouteElement: React.FC<{
  component: React.ReactElement
  fallbackRedirectTo?: string
  loggedIn?: boolean
  name: string
  shouldRenderRoute?: boolean
}> = ({
  component: Component,
  loggedIn = false,
  shouldRenderRoute = true,
  name,
  fallbackRedirectTo = '/'
}) => {
  const { currentTeamId } = useAuth()

  useEffect(() => {
    // DO NOT send PAGE events to segment for public-facing pages
    // this creates an anonymous MTU and these add up and cost us significantly in our Segment bill
    // if users login then their anonymous events are tied to their id and tracked
    // but the login page is public and anyone (or any bot) can hit it and cost us money!
    if (loggedIn) {
      trackPage(name, {
        loggedIn,
        teamId: currentTeamId
      })
    }
  }, [
    currentTeamId, // We want to fire if teamId changes
    name,
    loggedIn
  ])

  return shouldRenderRoute ? Component : <Navigate to={fallbackRedirectTo} />
}
